import { useAuthStore } from '@/stores/authStore'

export default function requireAuth() {
    const auth = useAuthStore()
    auth.loadUser()

    if (!auth.user) return '/'
}
